import React, { useState, useEffect } from "react";

import PropTypes from "prop-types";
import { useApolloClient } from "react-apollo";
import { Title } from "rbx";
import moment from "moment";

import gql from "graphql-tag";
import { ReactTable } from "../../../../components/DataTable";
import { EMPLOYEE_CERTIFICATION_COLUMNS } from "./columns";
import { getDaysDiffBetweenDates } from "../../../../utils";

const EMPLOYEE_CERTIFICATIONS = gql`
  query EmployeeCertifications($where: EmployeeCertificationWhereInput) {
    EmployeeCertifications(where: $where) {
      RecId
      CertificationName
      LastTestDate
      ExpirationDate
      Type {
        RecId
        CodeDescription
      }
      Employee {
        RecId
        FullName
      }
    }
  }
`;

const CertificationModal = ({ employeeRecIdRef, pickupDate }) => {
  const client = useApolloClient();

  const [data, setData] = useState([]);
  const [name, setName] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const {
        data: { EmployeeCertifications = [] }
      } = await client.query({
        query: EMPLOYEE_CERTIFICATIONS,
        variables: {
          where: {
            EmployeeRecIdRef: employeeRecIdRef
          }
        }
      });
      if (
        EmployeeCertifications.length &&
        EmployeeCertifications[0] &&
        EmployeeCertifications[0].Employee
      ) {
        setName(EmployeeCertifications[0].Employee.FullName);
      }
      const withDaysToExpire = EmployeeCertifications.map(x => ({
        ...x,
        DaysToExpire: x.ExpirationDate
          ? Math.ceil(
              getDaysDiffBetweenDates(
                new Date(pickupDate),
                new Date(x.ExpirationDate)
              )
            )
          : ""
      }));

      setData(withDaysToExpire);
    };
    fetchData();
  }, [client, employeeRecIdRef, pickupDate]);

  return (
    <div>
      <div
        style={{
          marginBottom: 25,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end"
        }}
      >
        <div>
          <Title size={4}>{name}</Title>
          <Title subtitle size={5}>
            Exams / Certifications
          </Title>
        </div>
        <div>
          <Title size={4}>{moment(pickupDate).format("MM/DD/YYYY")}</Title>
        </div>
      </div>
      <ReactTable
        columns={EMPLOYEE_CERTIFICATION_COLUMNS}
        data={data}
        sortBy={[{ id: "DaysToExpire", desc: false }]}
      />
    </div>
  );
};

CertificationModal.propTypes = {
  employeeRecIdRef: PropTypes.number,
  pickupDate: PropTypes.string
};
export default CertificationModal;
